import * as React from 'react';
import { useContext, useState } from 'react';
import { AuthContext } from '../../_auth/AuthContext';
import { NavigationContext } from '../../_navigation/NavigationContext';
import { Button, Grid, Typography } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import { IChangeEventHandler } from '../../_types/nav';
import { AuthenticationOptions, ChangeCredentialResultOptions, IAuthResult, ICredential } from '../../_types/user';
import { IPolicyObject } from '../../_types/ewpolicy';
import { CheckForEmail, CreateEmail } from '../../_service/auth';


interface Props {
    open: boolean,
    user: IPolicyObject,
    onChange: IChangeEventHandler<ICredential | null>
};

const NewEmailDialog: React.FC<Props> = (prop: Props) => {

    const { user } = useContext(AuthContext);
    const { nav } = useContext(NavigationContext);
    const [badEmail, setBadEmail] = useState<string>("");
    const [email, setEmail] = useState<string>("");

    React.useEffect(() => {
        setBadEmail("");

    }, [prop.open])

    const setInputEmail = (val:string) => {
        setEmail(val);
        setBadEmail("");
    }

    const validateAndGo = () => {

      

        if (email.length < 5) {
            setBadEmail("Name me one person with an email that short!");
        } else if (email.indexOf('@') === -1) {
            setBadEmail("Most emails have an @ symbol");
        } else {
            CheckForEmail(email).then(r => {

                if (r.result !== AuthenticationOptions.NoMatch as number) {
           
             
                    setBadEmail("Another user exists with this email");
                } else {

                    CreateEmail(prop.user.id!, email).then(r => {
                        if (r.result === ChangeCredentialResultOptions.Success) {
                            prop.onChange(r.credential!);
                        } else {
                            setBadEmail("Something went wrong");
                        }
                    })

                }

            });
            
        }

        
    }

    return (
        <Dialog fullWidth maxWidth="lg" scroll="paper" open={prop.open}>
            <DialogTitle>Add Email</DialogTitle>
            <DialogContent>
                <Grid container direction="column" justify="flex-start" alignItems="stretch" spacing={1}>
                    <Grid item>
                        <TextField multiline rows={4} defaultValue="" onChange={(val:React.ChangeEvent<HTMLInputElement>) => setInputEmail(val.target.value)} label="New Email" fullWidth/>
                    </Grid>
                    {(badEmail.length > 0) && (
                        <Grid item>
                            <Typography variant="button" color="error">{badEmail}</Typography>
                        </Grid>
                    )}
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={(e)=>{prop.onChange(null)}} color="primary" variant="outlined">Close</Button>
                <Button onClick={(e)=>{validateAndGo()}} color="primary" variant="outlined">Create</Button>
            </DialogActions>
        </Dialog>
    )
    
}

export default NewEmailDialog;